import { XButton } from '@adornis/chemistry/elements/components/x-button.js';
import { customElement } from 'lit/decorators.js';

@customElement('tr-button')
export class TrButton extends XButton {
  override styles() {
    return [
      ...super.styles(),
      {
        ':host > tr-link': {
          'text-decoration': 'unset',
        },
      },
    ] as any;
  }
}
